import React from 'react';
import { HeroTone } from '../../content/heroThemes';

/** Shared mesh, grid, and glow for learner heroes. */
const HeroBackdrop: React.FC<{ tone?: HeroTone }> = ({ tone = 'home' }) => (
  <div className="hero-backdrop" data-tone={tone} aria-hidden>
    <div className="hero-backdrop__grid" />
    <div className="hero-backdrop__orb hero-backdrop__orb--a" />
    <div className="hero-backdrop__orb hero-backdrop__orb--b" />
    <div className="hero-backdrop__orb hero-backdrop__orb--c" />
  </div>
);

export default HeroBackdrop;
